document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.js-top-mv-swiper');
  if (!swiperEl) return;

  const scrolldown = document.querySelector('.top__mv-scrolldown');

  new Swiper('.js-top-mv-swiper', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: false,
    speed: 1600,
    allowTouchMove: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      stopOnLastSlide: true,
    },
    on: {
      slideChangeTransitionStart(swiper) {
        if (swiper.isEnd && scrolldown) {
          scrolldown.classList.add('-is-visible');
        }
      },
    },
  });
});
